export default {"src":"/_next/static/media/bag_sharp.6b0ba10b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};